export default __webpack_public_path__ + "static/media/buyPurchasesTranslate.696e9f9d.png";